import { DeleteButton } from "./DeleteButton";

const fmt = (iso) =>
  new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const SubscriberTable = ({ rows, onDelete }) => {
  if (!rows.length) {
    return (
      <p data-testid="admin-empty-state" className="mt-16 text-center text-[#5f5e5a] font-mono-d text-[11px] uppercase tracking-[0.2em]">
        No subscribers found.
      </p>
    );
  }
  return (
    <div className="mt-8 border border-[#e3e2dc] rounded-3xl overflow-hidden bg-[#faf9f6]">
      <table data-testid="admin-subscriber-table" className="w-full text-sm">
        <thead>
          <tr className="font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] border-b border-[#e3e2dc]">
            <th className="text-left font-normal px-6 py-4">#</th>
            <th className="text-left font-normal px-6 py-4">Email</th>
            <th className="text-left font-normal px-6 py-4 hidden sm:table-cell">Name</th>
            <th className="text-left font-normal px-6 py-4">Size</th>
            <th className="text-left font-normal px-6 py-4 hidden md:table-cell">Email sent</th>
            <th className="text-left font-normal px-6 py-4 hidden md:table-cell">Joined</th>
            <th className="px-6 py-4" />
          </tr>
        </thead>
        <tbody>
          {rows.map((s, i) => (
            <tr
              key={s.id}
              data-testid={`subscriber-row-${s.id}`}
              className="border-b border-[#e3e2dc] last:border-0 hover:bg-[#ffffff]/60 transition-colors"
            >
              <td className="px-6 py-4 text-[#5f5e5a] font-mono-d text-xs">{String(i + 1).padStart(3, "0")}</td>
              <td className="px-6 py-4">{s.email}</td>
              <td className="px-6 py-4 text-[#5f5e5a] hidden sm:table-cell">{s.name || "—"}</td>
              <td className="px-6 py-4 font-mono-d text-xs">{s.size || "—"}</td>
              <td className="px-6 py-4 hidden md:table-cell">
                <span className={`inline-block rounded-full px-2.5 py-1 font-mono-d text-[9px] uppercase tracking-[0.15em] ${s.welcome_email === "sent" ? "bg-[#0a0a0b] text-white" : s.welcome_email === "failed" ? "bg-[#ff2a85]/10 text-[#ff2a85]" : "bg-[#f3f2ec] text-[#5f5e5a]"}`}>
                  {s.welcome_email || "n/a"}
                </span>
              </td>
              <td className="px-6 py-4 text-[#5f5e5a] hidden md:table-cell font-mono-d text-xs">{fmt(s.created_at)}</td>
              <td className="px-6 py-4 text-right">
                <DeleteButton size="sm" testId={`subscriber-delete-${s.id}`} title="Remove subscriber?" confirmLabel="Remove"
                  description={`${s.email} will be removed from your list and won't receive drop emails.`} onConfirm={() => onDelete(s.id)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
